import { render, staticRenderFns } from "./reportProficientRoomFee.vue?vue&type=template&id=746dc3a2&scoped=true"
import script from "./reportProficientRoomFee.vue?vue&type=script&lang=js"
export * from "./reportProficientRoomFee.vue?vue&type=script&lang=js"
import style0 from "./reportProficientRoomFee.vue?vue&type=style&index=0&id=746dc3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746dc3a2",
  null
  
)

export default component.exports